/** One responsive composer surface for web and native QuantisAI controls. */
import React from 'react';
import {Platform, StyleSheet, View} from 'react-native';
import {useSharedPalette} from '../theme';

export const QUANTIS_AI_COMPOSER_METRICS = {inputMinHeight: 32, inputMaxHeight: 120, controlSize: 32, radius: 16} as const;

export function QuantisAIComposerFrame({input, attachments, leading, trailing, action, material, accessibilityLabel}: {
  input: React.ReactNode; attachments?: React.ReactNode; leading?: React.ReactNode; trailing?: React.ReactNode;
  action: React.ReactNode; material?: React.ReactNode; accessibilityLabel?: string;
}) {
  const palette = useSharedPalette();
  const [width, setWidth] = React.useState(0);
  return <View testID="quantis-ai-composer" accessibilityLabel={accessibilityLabel}
    onLayout={event => {const next = event.nativeEvent.layout.width; setWidth(previous => previous === next ? previous : next);}}
    style={[styles.outer, {paddingHorizontal: width >= 600 ? 24 : 12}]}>
    <View testID="quantis-ai-composer-surface" style={[styles.surface, Platform.OS !== 'web' && !material && {backgroundColor: palette.canvas, borderColor: palette.border, borderWidth: 1}]}>
      {material}
      {attachments}
      <View style={styles.editor}>{input}</View>
      <View style={styles.toolbar}>
        <View style={styles.leading}>{leading}</View>
        <View style={styles.trailing}>{trailing}{action}</View>
      </View>
    </View>
  </View>;
}
const styles = StyleSheet.create({
  outer: {width: '100%', maxWidth: 1400, alignSelf: 'center', flexShrink: 0, paddingTop: 8, paddingBottom: 12},
  surface: {borderRadius: QUANTIS_AI_COMPOSER_METRICS.radius, padding: 8},
  editor: {minHeight: QUANTIS_AI_COMPOSER_METRICS.inputMinHeight, marginBottom: 4},
  toolbar: {minHeight: QUANTIS_AI_COMPOSER_METRICS.controlSize, flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: 8},
  leading: {flexDirection: 'row', flexWrap: 'wrap', alignItems: 'center', gap: 2, flexShrink: 1, minWidth: 0},
  trailing: {flexDirection: 'row', alignItems: 'center', gap: 2, flexShrink: 0},
});
